<template>
  <div class="boss-message-box">
    <img
      src="@/assets/images/avatar-company.svg"
      class="boss-message-box-avatar"
    >
    <div class="boss-layout-block">
      <entry-message-history-message-detail
        :date="date"
        :is-read="isRead"
        :subject="subject"
        :body="body"
        :is-remind-mail="isRemindMail"
      />
      <entry-message-history-interview-adjustment
        v-if="interviewAdjustment"
        :candidate-dates="interviewAdjustment.candidateDates"
        :place="interviewAdjustment.place"
        :google-map-place="interviewAdjustment.googleMapPlace"
        :duration="interviewAdjustment.duration"
        :content-names="interviewAdjustment.contentNames"
        :remarks="interviewAdjustment.remarks"
      />
      <template v-if="files.length">
        <div
          class="pega-file-download-content"
          data-test="file-content"
        >
          添付ファイル
        </div>
        <div
          v-for="(file, i) in files"
          :key="i"
          class="position-relative pega-break"
        >
          <span :data-test="`file-label-${i}`">
            {{ file | formatFile }}
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { formatBytes } from '@/lib/formatBytes'
import EntryMessageHistoryMessageDetail from '@/components/molecules/EntryMessageHistoryMessageDetail'
import EntryMessageHistoryInterviewAdjustment from '@/components/molecules/EntryMessageHistoryInterviewAdjustment'

export default {
  filters: {
    formatFile (file) {
      if (dayjs().isAfter(dayjs(file.expiredDate), 'days')) {
        return `${file.name} 閲覧期限終了`
      } else if (file.deletedCompanyStaff && file.manualDeletedDate) {
        return `${file.name} ${file.deletedCompanyStaff}によって${dayjs(file.manualDeletedDate).format('YYYY-MM-DD')}に削除済み`
      } else {
        const sizeLabel = `(${formatBytes(file.size)})`
        return `${file.name}${sizeLabel} 閲覧期限 ${dayjs(file.expiredDate).format('YYYY-MM-DD')}`
      }
    }
  },
  components: {
    EntryMessageHistoryMessageDetail,
    EntryMessageHistoryInterviewAdjustment
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      default: ''
    },
    subject: {
      type: String,
      default: ''
    },
    isRead: {
      type: Boolean,
      default: false
    },
    interviewAdjustment: {
      type: Object,
      default: () => (null)
    },
    files: {
      type: Array,
      default: () => []
    },
    isRemindMail: {
      type: Boolean,
      default: false
    }
  }
}
</script>
